<template>
	<AppAvatarGroup :numToShow="numToShow" :userIds="sharedUsersIds" :groupIds="sharedGroupsIds" :tooltipDirection="tooltipDirection" />
</template>
<script>
import { teamMembers } from '@/store/modules/account/getters';
import { groups } from '@/store/modules/accountGroups/getters';
import { setProjectShareData } from '@/store/modules/projects/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { projectSharedData, projectSharedDataLoading } from '@/store/modules/projects/getters';
export default {
	name: 'ProjectAvatars',
	props: {
		projectId: { type: Number },
		numToShow: { type: Number, default: 3 },
		forceGet: { type: Boolean, default: false },
		fetchData: { type: Boolean, default: true },
		tooltipDirection: { type: String, default: 'top' },
	},
	computed: {
		...mapGettersShorthand({ projectSharedData, projectSharedDataLoading, teamMembers, groups }),
		sharedData() {
			return this.projectSharedData(this.projectId);
		},
		sharedUsersIds() {
			return this.sharedData?.shared_users?.map((user) => user.id);
		},
		sharedGroupsIds() {
			return this.sharedData?.shared_groups?.map((g) => g.id);
		},
	},
	methods: { ...mapActionsShorthand({ setProjectShareData }) },
	async mounted() {
		if (this.fetchData) {
			await this.setProjectShareData({ id: this.projectId, force: this.forceGet });
		}
	},
};
</script>
